import React from 'react'

const Error = () => {
  return (
    <div className='recall-container'>
        <div className='error-message'>
        <p>入力エラー</p>
        <p>正しくない車台番号が入力されました。再度ご確認の上入力してください。</p>
        <p>戻る</p>
        </div>
    </div>
  )
}

export default Error